/* eslint-disable */
import Websocket from '@/utils/websocket';
import * as Comlink from 'comlink';
import Storage from './Storage';
const messageStorage = new Storage({ tableName: 'message', DBName: 'app_ws_action_temp_storage' });
const breakPointStore = new Storage({ tableName: 'break-point', DBName: 'app_break_point_storage' });
import {
  BroadcastChannel
} from 'broadcast-channel';

const EVENT_NAME_MAP = {
  'add:Issue.i_issue': 'issueAddNotice',
  'update:Issue.i_issue': 'issueUpdateNotice',
  'delete:Issue.i_issue': 'issueDeleteNotice',
  'unreads:Issue.unreads': 'issueUnreadNotice',
  'update:Issue.detail': 'issueUpdate',
  'add:Issue.detail': 'issueAdd',
  'del:Issue.detail': 'issueDelete',
  'update:Sprint.detail': 'sprintUpdate',
  'add:Sprint.detail': 'sprintAdd',
  'del:Sprint.detail': 'sprintDelete',
  'update:IssueType.detail': 'issueTypeUpdate',
  'add:IssueType.detail': 'issueTypeAdd',
  'del:IssueType.detail': 'issueTypeDelete',
  'update:Workflow.detail': 'workflowUpdate',
  'sysNotify:sys.notify': 'sysNotify',
  'rolePermission:role_permission_change': 'rolePermissionUpdate',
  'multiRolePermission:multi_role_permission_change': 'userPermissionUpdate',
  'projectUserOperate:project_user_opt': 'projectUserOpt',
  'tenantRightChange:tenant_right_change': 'tenantRightChange',
  'automationSuggest:automation_suggest': 'smartAssistantRecommendationMessage',
  'userPinRemove:user_pin_change': 'userPinRemove',
  'userPinAdd:user_pin_change': 'userPinAdd',
  'issueLayoutModify:IssueLayout.detail': 'issueLayoutModify',
  'integrationSlack:integration_slack': 'slackIntegrationChange',
  'integrationTeams:integration_teams': 'teamsIntegrationChange',

  // web im 推送事件
  'query:ai.markdown': 'queryAIMarkdown',
  'query:ai.receive.report.data': 'queryAIReceiveReportData',
  'query:ai.noneData': 'queryAINoneData',
  'query:ai.issue': 'queryAIIssue',
  'query:ai.text': 'queryAIMarkdown',
  'recommend:ai.receiveRecommendData': 'queryAIRecommendData',
  'recommend:ai.receiveRecommendDataFilter' : 'queryAIRecommendData',
  'recommend:ai.example' : 'queryAIRecommendData',
  'input:ai.input.text': 'aiInputText',
  'risk:ai.sprint.risk.status': 'queryAISprintRiskData',
  'automation:ai.automation': 'queryAIAutomation',
  'automation:ai.automation.error': 'queryAIAutomationError',
  'automation:ai.automation.ask.project': 'queryAIAutomationAskProject',
  // web im ai 使用量不足时，tips
  'query:ai.right.block': 'queryAIRightBlock'
  /*,
  /*,
  'importResult:Issue.import': 'importResult'*/
};
const fnMap = {};
const eventNameMap = {};
class wsWorker extends Websocket {
  init({url, opt, userId, channelName, instanceId}){
    setTimeout(() => {
      messageStorage.clear();
      breakPointStore.clear();
    }, 0);
    if (this.userId !== userId) {
      super.clear();
    }
    super.connect(url, opt);
    this.channel = new BroadcastChannel(channelName, {
      webWorkerSupport: true
    });
    this.instanceId = instanceId;
    this.userId = userId;
  }
  onActionMessage(data) {
    setTimeout(() => messageStorage.save({ ...data, timestamp: Date.now() }), 0);
    if (data.msgType === 'user_pin_change') {
      data.result = {...data};
    }
    if (!data || !data.result) {
      return;
    }
    console.log('---onActionMessage--', data);
    const { action, msgType, result } = data;
    const key = `${action}:${msgType}`;
    const eventName = EVENT_NAME_MAP[key];
    this.channel?.postMessage({eventName, result, data, workerInstanceId: this.instanceId});
  }
  on(eventName, mark){
    const _this = this;
    const fn = function(data){
      _this.channel?.postMessage({eventName, data, workerInstanceId: _this.instanceId, type: 'global', mark});
    }
    fnMap[mark] = fn;
    if (!eventNameMap[eventName] || !eventNameMap[eventName].length) {
      eventNameMap[eventName] = [];
      super.on(eventName, fn);
    }
    eventNameMap[eventName].push(mark);
  }
  off(eventName, mark){
    const list = eventNameMap[eventName];
    if (!list) {
      return;
    }
    eventNameMap[eventName] = list.filter(i => i !== mark);
    if (!eventNameMap[eventName].length) {
      super.off(eventName, fnMap[mark]);
      delete fnMap[mark];
    }
  }
  saveBreakPoint(breakPoint, duration, reconnectionTime) {
    // 保存断线时间，持续时间，重连时间
    setTimeout(() => {
      breakPointStore.save({
        breakPoint: new Date(breakPoint),
        duration: `${(duration / 1000).toFixed(0)}秒`,
        reconnectionTime: new Date(reconnectionTime),
        saveTime: new Date()
      })
    })
  }
}

const instance = new wsWorker();

self.onconnect = (e) => {
  const port = e.ports[0];
  Comlink.expose(instance, port);
};

Comlink.expose(instance);

export default instance;
